import { useGetPatientUsProviderGroupProfileQuery } from "api/hooks/useGetPatientUsProviderGroupProfileQuery";
import { useGetUsPatientInsuranceQuery } from "api/hooks/useGetUsPatientInsuranceQuery";

const formatInsuranceCompanyName = (name: string) => {
  return name.charAt(0).toUpperCase() + name.slice(1);
};

type InsuranceInfo = {
  name: string;
  memberID?: string;
};

export const usePrimaryInsuranceInfo = (patientID: number): InsuranceInfo | null => {
  const { data: providerGroupData } = useGetPatientUsProviderGroupProfileQuery({ patientId: patientID });
  const { data: insuranceData } = useGetUsPatientInsuranceQuery({ patientId: patientID });

  if (providerGroupData?.us_provider_group_clinic?.name) {
    return { name: providerGroupData.us_provider_group_clinic.name };
  }

  if (insuranceData?.insurance_found && insuranceData?.data?.insurance_company_name) {
    const insuranceCompanyName = formatInsuranceCompanyName(insuranceData.data.insurance_company_name);
    return { name: insuranceCompanyName, memberID: insuranceData.data.member_id };
  }

  return null;
};
